window.infoLoteMateriaPrimaInyeccion = null;

if (window.location.pathname === '/inyeccion/periodo' || window.location.pathname === '/zona-trabajo') {

    window.infoLoteMateriaPrimaInyeccion = (idLineaLoteMateriaPrima) => {
        const url = `/api/inyeccion/lineaLoteMateriaPrima?idLine=${idLineaLoteMateriaPrima}`;
        const formEditar = document.querySelector('#formEditarLoteMateriaPrimaInyeccion');
        const contEditar = document.querySelector('#contEditarLoteMateriaPrimaInyeccion');

        fetch(url, { method: 'GET', credentials: 'include' })
            .then(response => {
                if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
                return response.json();
            })
            .then(result => {
                const data = result.result[0];
                if (!data || !formEditar) return;

                contEditar.querySelectorAll('.inputRojo').forEach(el => el.classList.remove('inputRojo'));

                formEditar.querySelector('#horaInicio').value = data.horaInicio || '';
                formEditar.querySelector('#horaFin').value = data.horaFin || '';
                formEditar.querySelector('#numeroLote').value = data.numeroLote || '';
                formEditar.querySelector('#observacionesLote').value = data.Observaciones || '';
            })
            .catch(error => {
                console.error('Error al cargar info del lote:', error);
                alert('Error al cargar la información del lote. Por favor, intenta de nuevo.');
                window.location.reload();
            });
    };

    document.addEventListener('click', function (e) {
        const fila = e.target.closest('.trSelectLoteMateriaPrimaInyeccion');
        if (!fila) return;

        const idLote = fila.getAttribute('data-id');
        const idMateriaPrima = fila.getAttribute('data-id-materia-prima');
        const material = fila.getAttribute('data-material');

        const formEditar = document.querySelector('#formEditarLoteMateriaPrimaInyeccion');
        const formReporte = document.querySelector('#formProduccionInyeccion');

        if (!formEditar || !formReporte || !idLote || isNaN(idLote)) {
            alert('Error al abrir el modal. Por favor, intenta de nuevo.');
            //window.location.reload();
            return;
        }

        const idReporte = formReporte.querySelector('#idReporteInyeccion').value;
        if (!idReporte) {
            alert('Error al obtener el reporte. Por favor, intenta de nuevo.');
            window.location.reload();
            return;
        }

        formEditar.querySelector('#idLineaLoteMateriaPrima').value = idLote;
        formEditar.querySelector('#idEncabezadoReporteInyeccion').value = idReporte;
        formEditar.querySelector('#idMateriaPrima').value = idMateriaPrima || '';
        formEditar.querySelector('#material').value = material || '';

        window.infoLoteMateriaPrimaInyeccion(idLote);
    });

    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formEditarLoteMateriaPrimaInyeccion') return;

        const botonActivo = e.submitter;
        if (!botonActivo || botonActivo.id !== 'btnEditarLoteMateriaPrimaInyeccion') return;

        e.preventDefault();

        const formulario = e.target;
        const modalPadre = formulario.closest('.modal');
        const spinner = formulario.querySelector('#spinner');
        const btnEditar = formulario.querySelector('#btnEditarLoteMateriaPrimaInyeccion');

        const formData = new FormData(formulario, botonActivo);

        btnEditar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(el => el.classList.remove('inputRojo'));

        try {
            const respuesta = await fetch('/api/inyeccion/editar-lote-materia-prima', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json;
            try {
                json = await respuesta.json();
            } catch {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok) {
                lanzarAlerta('Error al procesar la solicitud.', 'alerta-roja');
                return;
            }

            if (!json || !json.result) {
                lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                if (Array.isArray(resultado.errores)) {
                    resultado.errores.forEach(function (error) {
                        lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                        if (error.campo) {
                            const campo = formulario.querySelector('[name="' + error.campo + '"]');
                            if (campo) campo.classList.add('inputRojo');
                        }
                    });
                }
                return;
            }

            const idReporte = formulario.querySelector('#idEncabezadoReporteInyeccion').value;
            const params = new URLSearchParams(window.location.search);
            const mes = params.get('mes');
            const anio = params.get('año');

            if (modalPadre) modalPadre.classList.remove('modal--show');

            lanzarAlerta(resultado.mensaje || 'Lote editado con éxito.', 'alerta-verde');

            if (typeof window.actualizarModalReporteInyeccion === 'function' && idReporte) {
                window.actualizarModalReporteInyeccion(idReporte);
            }

            if (typeof window.actualizarTableroInyeccionPeriodo === 'function') {
                window.actualizarTableroInyeccionPeriodo(mes, anio);
            }

            if (typeof window.actualizarTablaInyeccionPeriodo === 'function') {
                window.actualizarTablaInyeccionPeriodo(mes, anio);
            }

            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }

        } catch (error) {
            console.error('Error:', error);
            lanzarAlerta('Error crítico al procesar la solicitud.', 'alerta-roja');
        } finally {
            if (btnEditar) btnEditar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}
